export const primaryColor = "#2897FE";